export enum UserPermissionType {
  ViewArchived = 'ROLE_VIEW_ARCHIVED',
  ViewCustomers = 'ROLE_VIEW_CUSTOMERS',
  ViewDashboard = 'ROLE_VIEW_DASHBOARD',
  ViewDocuments = 'ROLE_VIEW_DOCUMENTS',
  ViewGroups = 'ROLE_VIEW_GROUPS',
  ViewTemplates = 'ROLE_VIEW_TEMPLATES',
  ViewTracelogs = 'ROLE_VIEW_TRACELOGS',
  ViewUsers = 'ROLE_VIEW_USERS',
  SelectAllUsers = 'ROLE_SELECT_ALL_USERS',
  CopyMetadata = 'ROLE_COPY_METADATA',
  UpdateMetadata = 'ROLE_UPDATE_METADATA',
  ArchiveDocuments = 'ROLE_ARCHIVE_DOCUMENTS',
  DeleteDocuments = 'ROLE_DELETE_DOCUMENTS',
}
